import * as React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';
import { StyledComponentProps } from '@material-ui/core/styles';

import CancelButton from '../../../ui-components/Button/CancelButton';
import { reminder } from '../../../model/reminder';
import NewItemIconButton from '../../../ui-components/Button/NewItemIconButton';
import { ReminderList } from './ReminderList';

// interface IProps extends IMediaQueryProps, IReminderActions, IReminderState, IIProps {
//     // IContactActions,
// }

interface IIProps extends StyledComponentProps {
    onCancel: () => any;
    doneReminder: (r: reminder, done: boolean) => void;
    openReminder: (id: string) => void;
    newReminder: () => void;
    // onSave: (reminder: reminder) => any;
    open: boolean;
    isLoadingReminders: boolean;
    reminderList: reminder[];
}
interface IState {
    // selectedReminder: reminder;
    // openReminderDialog: true
}

// class ReminderAddItemDialog extends React.Component<IProps, IInnerState> {
export default class ReminderDialogList extends React.Component<IIProps, IState> {

    constructor(p, c) {
        super(p, c);
        this.state = {
            // selectedReminder: emptyReminder(),
        }
    }

    // getContactDescription = (contact: contact) => {
    //     return contact.surname ? (contact.surname + " " + contact.name) : contact.email;
    // }
    componentDidMount() {
        // console.log("-------------------------------------componentDidMount");
        // console.log(this.props.reminderList);
        // this.props.loadReminders('');
    }
    // handleSelection = (_id: string) => {
    //     console.log("-------------------------------------handleSelection");
    //     // console.log(_id);
    //     // this.setState({ contactsCollapsed: this.props.smallScreen ? true : this.state.contactsCollapsed });
    //     // this.props.loadTrainer(_id);
    //     // var r = this.props.reminderList.find(rr => rr._id === _id);
    //     // console.log(r);
    //     // openReminderDialog: true
    //     // this.setState({
    //     //     selectedReminder: r,
    //     // })
    // }

    render() {
        // const { classes } = this.props;
        var title = "Lista Promemoria";
        return (
            <Dialog
                open={this.props.open}
                onClose={(e) => this.props.onCancel()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
                <DialogContent>
                    <Grid container justify={"center"}>
                        {this.props.isLoadingReminders ?
                            <Grid item xs={12} style={{ display: 'flex' }}>
                                <CircularProgress size={80} />
                            </Grid>
                            :
                            <>
                                <Grid item xs={12} >
                                    <ReminderList
                                        classes={this.props.classes}
                                        reminderList={this.props.reminderList}
                                        selected={null}
                                        doneReminder={this.props.doneReminder}
                                        onReminderClick={this.props.openReminder}
                                        showContactInfo={false}
                                    // navigateTo={this.props.navigateTo}
                                    />
                                </Grid>
                            </>
                        }

                    </Grid>
                </DialogContent >
                <DialogActions>
                    <NewItemIconButton onClick={this.props.newReminder} />
                    <CancelButton onClick={this.props.onCancel} />
                </DialogActions>
            </Dialog >
        );
    }
}

// const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
//     return {
//         ...ownProps,
//     }
// }

// const mapDispatchToProps = (dispatch: any) => ({
//     ...remindersActions(dispatch)
// })

// export default connect(mapStateToProps, mapDispatchToProps)((WithMediaQuery(ReminderDialogList))) as React.ComponentType<IProps>;